import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import { forwardRef } from 'react';

export type IIconButtonProps = Omit<MuiIconButtonProps, 'ref' | 'name'> & {
    name: string;
};

export const IconButton = forwardRef<HTMLButtonElement, IIconButtonProps>(function InnerButton(
    { hidden, ...props },
    ref
) {
    return <MuiIconButton {...props} ref={ref} hidden={hidden} style={{ display: hidden ? 'none' : '' }} />;
});
